import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { RequestCount } from '../interfaces/requestCount.interface';
import { SessionService } from '../session/session.service';
@Injectable()
export class NavMenuService {
  constructor(
    protected http: HttpClient,
    protected session: SessionService,
    @Inject('API_URL') protected apiUrl: string
  ) { }

  public getNrOfWaitingRequests(): Observable<RequestCount> {
    const url = `${this.apiUrl}/InformationRequest/NrOfWaitingRequests`;
    return this.http.get<RequestCount>(url);
  }
}
